import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ComplaintSubmissionDialogComponent } from 'app/components/complaints/complaint-submission-dialog/complaint-submission-dialog.component';
import { SharedService } from 'app/services/core/shared.service';

@Injectable({
  providedIn: 'root'
})
export class ComplaintDialogService {
  private readonly dialogId = 'public-complaint-submission-dialog';

  constructor(
    private readonly dialog: MatDialog,
    private readonly sharedService: SharedService,
  ) {}

  open(): MatDialogRef<ComplaintSubmissionDialogComponent> {
    const existingDialog = this.dialog.getDialogById(this.dialogId) as MatDialogRef<ComplaintSubmissionDialogComponent> | undefined;
    if (existingDialog) {
      return existingDialog;
    }

    return this.dialog.open(ComplaintSubmissionDialogComponent, {
      id: this.dialogId,
      width: '95%',
      maxWidth: '960px',
      maxHeight: '95vh',
      height: this.sharedService.isMobile ? '95vh' : undefined,
      autoFocus: false,
      restoreFocus: true,
    });
  }
}